import { Directive, ElementRef, OnDestroy, OnInit, inject } from "@angular/core";

@Directive({ selector: "[mnClickActivate]" })
export class ClickActivateDirective implements OnInit, OnDestroy {
  private readonly eR = inject(ElementRef);

  private readonly activate = (): void => {
    this.nE.classList.add("activated");
  };
  private readonly deactivate = (): void => {
    this.nE.classList.remove("activated");
  };

  public ngOnInit(): void {
    this.nE.addEventListener("pointerdown", this.activate);
    this.nE.addEventListener("pointerup", this.deactivate);
    this.nE.addEventListener("pointercancel", this.deactivate);
  }

  public ngOnDestroy(): void {
    this.nE.removeEventListener("pointerdown", this.activate);
    this.nE.removeEventListener("pointerup", this.deactivate);
    this.nE.removeEventListener("pointercancel", this.deactivate);
  }

  public get nE(): HTMLElement {
    return this.eR.nativeElement;
  }
}
